export interface KeyPose {
	depth: number;
	x: number;
	y: number;
}

export function keyPoseTransform(
	pose: KeyPose,
	width: number,
	heightAboveStem: number,
): string {
	const magnitude = Math.hypot(pose.x, pose.y);
	const angle = magnitude * ((3 * Math.PI) / 180);
	const directionX = magnitude === 0 ? 0 : pose.x / magnitude;
	const directionY = magnitude === 0 ? 0 : pose.y / magnitude;
	const compression = 1 - Math.cos(angle);
	const displacement = heightAboveStem * Math.sin(angle);

	// A weak-perspective depth cue keeps a centre press visible in the top-down artwork.
	// Both layers share the same scale and rotation; only their height above the stem differs.
	const scale = 1 - 0.01 * pose.depth;
	const travel = width * 0.025 * pose.depth;
	const xx = scale * (1 - compression * directionX * directionX);
	const xy = scale * (-compression * directionX * directionY);
	const yy = scale * (1 - compression * directionY * directionY);
	const translateX = scale * displacement * directionX;
	const translateY = scale * displacement * directionY + travel;

	// Project into an SVG affine matrix rather than relying on CSS 3D transforms in WebKit.
	return `matrix(${xx},${xy},${xy},${yy},${translateX},${translateY})`;
}
